import component from './component';

export default [
    {
        path: '/town/sponsor/heysong',
        exact: true,
        component,
    },
];
